import Timber from './imgs/wood.jpg';

const TimberData = [
    {
        id:"1",
        imgsrc: Timber,
        title: "500D TMT Bar",
        qty: "1 Ton",
        cost: "₹1600.00"
    },
    {
        id:"2",
        imgsrc: Timber,
        title: "500D TMT Bar",
        qty: "1 Ton",
        cost: "₹1600.00"
    },
    {
        id:"3",
        imgsrc: Timber,
        title: "500D TMT Bar",
        qty: "1 Ton",
        cost: "₹1600.00"
    },
    {
        id:"4",
        imgsrc: Timber,
        title: "500D TMT Bar",
        qty: "1 Ton",
        cost: "₹1600.00"
    },
    {
        id:"5",
        imgsrc: Timber,
        title: "500D TMT Bar",
        qty: "1 Ton",
        cost: "₹1600.00"
    },
    {
        id:"6",
        imgsrc: Timber,
        title: "500D TMT Bar",
        qty: "1 Ton",
        cost: "₹1600.00"
    },
    {
        id:"7",
        imgsrc: Timber,
        title: "500D TMT Bar",
        qty: "1 Ton",
        cost: "₹1600.00"
    },
    {
        id:"8",
        imgsrc: Timber,
        title: "500D TMT Bar",
        qty: "1 Ton",
        cost: "₹1600.00"
    },
    {
        id:"9",
        imgsrc: Timber,
        title: "500D TMT Bar",
        qty: "1 Ton",
        cost: "₹1600.00"
    },
    {
        id:"10",
        imgsrc: Timber,
        title: "500D TMT Bar",
        qty: "1 Ton",
        cost: "₹1600.00"
    },
];

export default TimberData;